import React from 'react';
import { CalendarDateService } from '@uplift/services';

export type MonthCellProps = {
  value?: string;
  format?: string;
};

export const MonthCell: React.FC<MonthCellProps> = ({ value, format = 'MMMM YYYY' }) => {
  if (typeof value === 'string'){
    const date = CalendarDateService.date(value);

    if (CalendarDateService.isDateObject(date) && date.isValid()) {
      return (
        <span>
          {date.format(format)}
        </span>
      );
    } else return <span>{value}</span>;
  }

  return null;
};
